import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import { BigHeadline } from "../components/styles/headlines"

const PricingPage = () => (
  <Layout>
    <Seo title="Bräute" />
    <section className="container px-6  mx-auto grid md:grid-cols-2 gap-12 mt-60 mb-20">
      <BigHeadline>
        Hochzeitsstyling
      </BigHeadline>
      <div className="justify-items-start">
        <p>
          Brautstyling ist für uns mehr als ein perfektes Ergebnis - es ist das Zusammenspiel aus handwerklichem Können, kreativer Expertise und dem Gefühl von Vertrauen und Sicherheit. Als zwei eigenständige Experten bündeln wir unsere Erfahrung, um jeder Braut ein harmonisches, hochwertiges Gesamtstyling zu bieten.
        </p>{" "}
        <br />
        <p>
          Unsere langjährige Erfahrung hat unseren gemeinsamen Stil geprägt: ein individueller Look, der Persönlichkeit, Wünsche und natürlich Ausstrahlung in den Mittelpunkt stellt. Jedes Styling entsteht maßgeschneidert - professionell umgesetzt, mit viel Herz und einem sicheren Gespühr für das Besondere.
        </p>{" "}
        <br />
        <p>
          Melde dich bei uns und wir stellen dir ein auf dich abgestimmtes Paket zusammen.
        </p>
      </div>
    </section>
    <section className="container px-6  mx-auto flex justify-center mt-60 mb-20">
      <div className="w-full">
        <BigHeadline>Preise & Leistungen</BigHeadline>
        {/************************************************************************************************** Herren*/}
        <details className="mt-8">
          <summary className="border-b-2 border-main pb-3 ">Basic-Paket</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p>
              <span className="font-headline">Ideal für die standesamtliche Hochzeit</span><br />
              Braut Make up - ohne Probetermin<br />
              Braut Frisur - ohne Probetermin<br />
              inkl. Lashes & Basic Haarschmuck<br />
              Styling im Salon
            </p>
            <p className="ml-2">370,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Damen*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">Glam-Paket</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p>
              <span className="font-headline">Ideal für die Hochzeitsfeier</span><br />
              Braut Make up - inkl. Probetermin / 2h max.<br />
              Braut Frisur - inkl. Probetermin / 2h max.<br />
              Styling im Salon<br />
              Styling in der Location für 50€ Aufpreis* möglixh<br/>
              <small>* entfällt bei 2 weiteren Gäste Stylings</small>
            </p>
            <p className="ml-2">550,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Kinder*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">Glam Deluxe-Paket</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p>
              <span className="font-headline">Der optimale Rund um Service</span><br />
              Braut Make up - inkl. Probetermin / 2h max.<br />
              Braut Frisur - inkl. Probetermin / 2h max.<br />
              inkl. Lashes & Basic Haarschmuck, Touch up Kits<br />
              inkl. Gast Styling / Make up & Haare inkl. Anfahrt zur Location*<br />
              <small>* Schloss Romrod, Villa Raab, Güterbahnhof, Seehotel Michaela. Anfahrt zu weiteren Locations 0,25€ pro km.</small>
            </p>
            <p className="ml-2">740,00€</p>
          </div>
        </details>
        {/************************************************************************************************** Strähnen*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">Zusatzleistungen</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Touch up Kit</p>
            <p className="ml-2">20,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Lashes kleben</p>
            <p className="ml-2">15,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Haarschmuck</p>
            <p className="ml-2">auf Anfrage</p>
          </div>
        </details>
        {/************************************************************************************************** Augen*/}
        <details>
          <summary className="border-b-2 border-main pb-3 mt-16">Gäste Styling</summary>

          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Make up (ohne Zusatzleistungen)</p>
            <p className="ml-2">100,00€</p>
          </div>
          <div className="flex justify-between  pt-5 pb-1 border-b border-main">
            <p className="font-headline">Hairstyling</p>
            <p className="ml-2">Preis nach Aufwand</p>
          </div>
        </details>
      </div>
    </section>
  </Layout>
)

export default PricingPage
